import React, { useImperativeHandle, useRef, useState } from "react";
import { RCCHookToast, RCCRefModalProps, RCCServicesApi} from "react-common-components";
import { useForm } from "react-hook-form";
import ModalTreeHierarchyMaps from "src/components/ModalTreeHierarchyMaps";
import { useTranslation } from "src/context/Translations/context";
import { MapsHierarchyTypes } from "src/pages/StrategicPlanning/Maps/interface";
import { standardErrorMessages } from "src/utils/errors";
import stringToNumber from "src/utils/stringToNumber";
import { IRefModalSWOTMapBounds } from "../interface";

const ModalSWOTMapBounds: React.ForwardRefRenderFunction<IRefModalSWOTMapBounds> = (_, ref) => {
	const { translate } = useTranslation(); 
	const { addToast } = RCCHookToast();
	const onCloseFunction = useRef<Function|undefined>();
	const modalActionsHierarchyMaps = useRef<RCCRefModalProps>(null);
	const [itensOrBonds,setItensOrBonds] = useState<"bonds"|"itens">();
	const [swotId,setSwotId] = useState<number>();
	const { 
		handleSubmit, 
		register,
		reset,
		unregister,
		setValue
	} = useForm();

	const onSubmit = async (data: any) => {
		
		try {
			let objectives = [] as string[];
			if(Object.keys(data).length !== 0 )
				objectives = Object.values(data[`selectedItens-${MapsHierarchyTypes.OBJECTIVES}`])?.filter((item: any) => typeof item === "string") as string[];
		
			if (itensOrBonds === "itens"){
				await RCCServicesApi.postRequest({
					method: "SWOT/InsertMapBonds",
					body: {
						ids:objectives?.map((x:string) => stringToNumber(x)),
						mes002Id:swotId
					}
				});	
			}else{
				await RCCServicesApi.postRequest({
					method: "SWOTStrategies/InsertObjectiveBonds",
					body: {
						ids:objectives?.map((x:string) => stringToNumber(x)),
						Mes005Id:swotId
					}
				});	
			}

			addToast({
				color: "green",
				description: translate("Vinculos alterados com sucesso" ),
				title: translate("Sucesso")
			});
			if(onCloseFunction.current)
				onCloseFunction.current(objectives?.map((x:string) => stringToNumber(x)));
				
			modalActionsHierarchyMaps.current?.closeModal();
		} catch (error) {
			standardErrorMessages(error, translate("Erro ao vincular item com objetivos"), addToast);
		}

	};

	const requestMapBonds = async (mes002Id:any ) => {
		try {
			const response = await RCCServicesApi.getRequest({
				method: "SWOT/MapBonds",
				urlParameters: {
					mes002Id	
				}
			});	

			response.data?.forEach((x:any) => {
				setValue(`selectedItens-${MapsHierarchyTypes.OBJECTIVES}.item-${x.mes003Mea003Id}`,x.mes003Mea003Id.toString());
			});

		} catch (error) {
			standardErrorMessages(error, translate("Erro ao buscar vinculos com objetivos"), addToast);
		}
	};

	const openSWOTItensHierarchyObjectives = async (itemId:number,onClose?:(mapsId?:string[])=>void) => {
		reset();
		setItensOrBonds("itens");
		setSwotId(itemId);
		onCloseFunction.current = onClose;
		requestMapBonds(itemId);
		modalActionsHierarchyMaps.current?.openModal();
	};

	const openSWOTBondsHierarchyObjectives = async (bondId:number,onClose?:(mapsId?:string[])=>void) => {
		reset();
		setItensOrBonds("bonds");
		setSwotId(bondId);
		onCloseFunction.current = onClose;
		modalActionsHierarchyMaps.current?.openModal();
	};


	useImperativeHandle(ref, () => ({
		openSWOTItensHierarchyObjectives,
		openSWOTBondsHierarchyObjectives
	}));

	return (
		<ModalTreeHierarchyMaps 
			ref={modalActionsHierarchyMaps}
			onSubmit={handleSubmit(onSubmit)}
			register={register}
			title={translate("Selecione os objetivos para associar")}
			checkLevelHierarchy = {[MapsHierarchyTypes.OBJECTIVES]}
			lastLevelHierarchy={MapsHierarchyTypes.OBJECTIVES} 
			selectOptions="multi"
			unregister={unregister}
		/>
	);
};

export default React.forwardRef(ModalSWOTMapBounds);
